import { transliterate } from 'transliteration';

const STOP_PUNCTUATIONS = ['.', ',', '+', '&', '_', '-'];

// source: https://en.wikipedia.org/wiki/List_of_legal_entity_types_by_country
const STOP_LEGAL_ENTITY_TYPE_ACRONYMS = [
  // Common
  'ltd',
  'plc',
  'pvt',
  'lp',
  'gp',
  // Bulgaria
  'ead',
  'ood',
  // Croatia
  'dd',
  'doo',
  // Denmark
  'ivs',
  'aps',
  'a/s',
  // Estonia
  'ou',
  'as',
  // Finland
  'oy',
  'oyj',
  // France
  'sarl',
  'sa',
  'sas',
  // Germany
  'gmbh',
  'co',
  'kg',
  'ag',
  // Greece
  'ae',
  'ee',
  'epe',
  // Hungary
  'bt',
  'kft',
  'nyrt',
  // Iceland
  'ehf',
  'hf',
  'saf',
  // Italy
  'ss',
  'srl',
  'spa',
  // Latvia
  'sia',
  'ks',
  // Lithuania
  'uab',
  'ab',
  'tub',
  // Luxembourg
  'scs',
  // Netherlands
  'bv',
  'nv',
  // Norway
  'asa',
  'ans',
  // Poland
  'spk',
  'sp',
  'spzoo',
  'zoo',
  // Portugal
  'lda',
  // Slovakia
  'sro',
  // Slovenia
  'dno',
  // Spain
  'sl',
  'sc',
  // Sweden
  'kb',
  'hb',
  // Albania
  'shpk',
  'sha',
  'shk',
  // Australia
  'llp',
  'inc',
  'pty',
  // Brazil
  'sociedade',
  'limitada',
  'ltda',
  // Cambodia
  'pte',
  // Canada
  'limited',
  // Ecuador
  'cia',
  // Egypt
  'sae',
  // Malaysia
  'plt',
  'bhd',
  'sdn',
  // Turkey
  'san',
  'sanayi',
  've',
  'tic',
  'ticaret',
  'sti',
  'ls',
  'lo',
  // Vietnam
  'cty',
  'tnhh',
];

const REMOVE_PUNCTUATION_REGEX = new RegExp(
  `[${STOP_PUNCTUATIONS.join('')}]`,
  'gi',
);
const REMOVE_STOP_WORDS_REGEX = new RegExp(
  STOP_LEGAL_ENTITY_TYPE_ACRONYMS.map(sw => `\\b(${sw})\\b`).join('|'),
  'gi',
);
const REMOVE_DUPLICATED_SPACES_REGEX = /[ ]+/gi;

const removeStopWords = (text: string): string =>
  text
    .toLowerCase()
    .replace(REMOVE_PUNCTUATION_REGEX, ' ')
    .replace(REMOVE_STOP_WORDS_REGEX, ' ')
    .replace(REMOVE_DUPLICATED_SPACES_REGEX, ' ')
    .trim();

/**
 * Ports the legacy `removeStopWords(transliterate(name))` preprocessing used
 * before the trigram similarity search — strips punctuation, common legal
 * entity suffixes (Ltd, GmbH, S.A., ...), and transliterates to latin script
 * so e.g. "Müller GmbH" and "Muller" score as similar.
 */
export const normalizeCompanyNameForSimilarity = (name: string): string =>
  removeStopWords(transliterate(name));
